
import { defineComponent, computed } from '@vue/composition-api';
import { FCButton } from '@fc/angie-ui';
import { useModal } from '~/composables/useModal';

export default defineComponent({
  name: 'WrapGloveSize',
  components: {
    FCButton,
  },
  props: {
    productTitle: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    function openSizeModal() {
      const width = Math.min(500, Math.floor(window?.innerWidth * 0.85));

      const { modalShow } = useModal({
        component: () => import('./SizeModal.vue'),
        modalProps: {
          componentName: 'SizeModal',
          reset: true,
          classes: 'modal-border-radius',
          width,
        },
      });

      modalShow();
    }

    const shouldShow = computed(() => {
      const lowercasedTitle = props?.productTitle?.toLowerCase();
      return lowercasedTitle?.includes('glove') || lowercasedTitle?.includes('wrap');
    });

    return {
      openSizeModal,
      shouldShow,
    };
  },
});
